import PropTypes from 'prop-types';
import React from 'react';

import { FaIcon } from 'components/Icons';
import { StyledPrintList } from './Component/styles';

export default function PrintAttachments ({ list }) {
    return (
        <StyledPrintList>
            {list.map(item =>
                <li key={item.hashId}>
                    <FaIcon name="FaPaperclip" />
                    {item.name}
                </li>)
            }
        </StyledPrintList>
    );
}

PrintAttachments.propTypes = { list: PropTypes.array.isRequired };
